import React from 'react';
import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { ImageLoader } from 'next/image';
import { urlFor } from '../../lib/sanity';
import { Article } from '../../pages/learn/articles/[slug]';
import styles from './ArticleCard.module.css';
import CategoryLabel from './articles/CategoryLabel';

const ArticleCard: FC<{ article: Article }> = ({ article }) => {
  const imageUrl: string | null = article.coverImageAsset
    ? urlFor(article.coverImageAsset).url() ?? null
    : article.coverVideoUrl ?? null;

  const categoryWords = article.category.split('-').map((categoryWord, index, array) => {
    array[index] = categoryWord.charAt(0).toUpperCase() + categoryWord.substr(1);
    return array;
  });
  const category = categoryWords[0].join(' ');

  const router = useRouter();
  const url = `${router.asPath}`;

  const categoryLabel = url === '/learn' ? <p className='ml-2 text-white'>{category}</p> : null;

  const myLoader: ImageLoader = ({ src }) => {
    return src;
  };

  return (
    <Link href={`/learn/${article.slug}`}>
      <a>
        <div className='relative inline-block w-full h-full bg-black cursor-pointer'>
          <div className={styles['card-wrapper']}>
            <div className={styles['image-wrapper']}>
              {imageUrl && (
                <Image
                  loader={myLoader}
                  alt={article.title}
                  src={imageUrl}
                  layout='fill'
                  objectFit='cover'
                  className='w-full h-56'
                  unoptimized
                />
              )}
            </div>
            <div className='absolute bottom-0 left-0 w-full h-36 bg-gradient-to-t from-black to-transparent' />
            <div className='absolute bottom-3 left-4'>
              <CategoryLabel
                hasImageCover={!!article.coverImageAsset}
                categoryLabel={categoryLabel}
              />
              <h3 className='text-white mt-1.5'>{article.title}</h3>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default ArticleCard;
